<template v-if="list.length" lang="html">
  <draggable
    :options="{ handle: '.dragging__dots' }"
    v-model="value"
    class="voice-bot__questions"
  >
    <question-row
      v-for="(item, index) in value"
      :model="item"
      :key="index"
      :index="index"
    ></question-row>
  </draggable>
</template>

<script>

import QuestionRow from './Row.vue'
import draggable from 'vuedraggable'

export default {
  name: 'vacancy-voicebot-question-list',

  components: {
    QuestionRow,
    draggable
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: Array
  }
}
</script>

<style scoped>
  .voice-bot__questions {
    width: 100%;
    margin-bottom: 40px;
  }
</style>
